import {Model} from '@ab/components';
import queryParams from '../queries/main.m.q';

export default class extends Model {
    static queryParams = queryParams;
}
